/**
 * @generated SignedSource<<7499b523d95aa6d7550948c9d0434ca3>>
 * @relayHash 4d0a7f11b9f1b0708434626c8ef3b98a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec32fb5a6eded895c7582841066145b19130f650d4d6f3ebb56bdeb934f0be30

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type YourAgentResultsQuery$variables = {
  cloudId: string;
  product?: string | null;
};
export type YourAgentResultsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"YourAgentResults_owned" | "YourAgentResults_starred">;
};
export type YourAgentResultsQuery = {
  response: YourAgentResultsQuery$data;
  variables: YourAgentResultsQuery$variables;
};
({
  "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isUpliftEnabled_provider from '@atlassian/studio-browse-kit/ui/agent-card/components/isAgentAuthorUpliftEnabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 24
},
v6 = [
  (v2/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyMyAgents": true
    }
  },
  (v3/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "picture"
},
v11 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "isVerified"
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "icon"
          },
          {
            "kind": "ScalarField",
            "name": "externalConfigReference"
          },
          {
            "kind": "ScalarField",
            "name": "identityAccountId"
          },
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appType"
                  }
                ],
                "type": "AppUser"
              },
              (v7/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "creatorType"
          },
          {
            "kind": "ScalarField",
            "name": "forgeCreator"
          },
          {
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "authoringTeam",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              (v7/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v8/*: any*/),
              {
                "kind": "ScalarField",
                "name": "accountStatus"
              },
              {
                "condition": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  }
                ]
              },
              (v7/*: any*/)
            ]
          },
          (v9/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "cursor"
      }
    ]
  },
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "endCursor"
      },
      {
        "kind": "ScalarField",
        "name": "hasNextPage"
      }
    ]
  }
],
v12 = [
  "cloudId",
  "product",
  "input"
],
v13 = [
  (v2/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyFavouriteAgents": true
    }
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "YourAgentResultsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "YourAgentResults_owned"
      },
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "YourAgentResults_starred"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "YourAgentResultsQuery",
    "selections": [
      {
        "alias": "ownedAgents",
        "args": (v6/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v11/*: any*/)
      },
      {
        "alias": "ownedAgents",
        "args": (v6/*: any*/),
        "filters": (v12/*: any*/),
        "handle": "connection",
        "key": "YourAgentResults_ownedAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      },
      {
        "alias": "starredAgents",
        "args": (v13/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v11/*: any*/)
      },
      {
        "alias": "starredAgents",
        "args": (v13/*: any*/),
        "filters": (v12/*: any*/),
        "handle": "connection",
        "key": "YourAgentResults_starredAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      }
    ]
  },
  "params": {
    "id": "ec32fb5a6eded895c7582841066145b19130f650d4d6f3ebb56bdeb934f0be30",
    "metadata": {},
    "name": "YourAgentResultsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
    }
  }
};
})();

(node as any).hash = "d080ebc78a6e9e9416d7c6efd2a04a2b";

export default node;
